/* Template lab de produto: cards de kit sobre o variant picker + comparador antes/depois. */
(function () {
  var cfg = window.PDP_LAB || {};

  function money(cents) {
    try {
      return (cents / 100).toLocaleString(cfg.locale || 'pt-BR', { style: 'currency', currency: cfg.currency || 'BRL' });
    } catch (e) {
      return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
    }
  }

  function decorateKits() {
    var picker = document.querySelector('.product-detail__variant-picker');
    if (!picker || !cfg.variants) return;
    var idx = -1;
    picker.querySelectorAll('label').forEach(function (label) {
      if (label.classList.contains('pl-kit')) { idx++; return; }
      var input = label.control || document.getElementById(label.getAttribute('for'));
      if (!input || input.type !== 'radio') return;
      var value = input.value;
      var variant = cfg.variants.find(function (v) { return v.option1 === value; });
      if (!variant) return;
      idx++;
      /* acha o kit pelo valor da variante; se não achar, usa a mesma posição da lista */
      var kit = (cfg.kits || []).find(function (k) { return k.match === value; }) || (cfg.kits || [])[idx] || {};
      var title = kit.title || label.textContent.trim() || value;
      var showOld = variant.compare > variant.price;
      label.classList.add('pl-kit');
      label.innerHTML =
        (kit.pill ? '<span class="pl-kit-pill">' + kit.pill + '</span>' : '') +
        '<span class="pl-dot"></span>' +
        '<span class="pl-kit-main"><span class="pl-kit-title">' + title + '</span>' +
        (kit.sub ? '<span class="pl-kit-sub">' + kit.sub + '</span>' : '') + '</span>' +
        '<span class="pl-kit-price"><b>' + money(variant.price) + '</b>' +
        (showOld ? '<s>' + money(variant.compare) + '</s>' : '') + '</span>';
    });
  }

  /* ===== personalização por peça: Colar 1 / Colar 2 ===== */
  function findKit(value, idx) {
    var kits = cfg.kits || [];
    return kits.find(function (k) { return k.match === value; }) || kits[idx] || null;
  }

  function selectedPieces() {
    var inputs = document.querySelectorAll('.product-detail__variant-picker input[type="radio"]');
    var pieces = 1;
    inputs.forEach(function (input, idx) {
      if (!input.checked) return;
      var kit = findKit(input.value, idx);
      if (kit && kit.pieces) pieces = kit.pieces;
    });
    return pieces;
  }

  function fieldOf(root, selector) {
    var el = root.querySelector(selector);
    return el ? el.closest('.custom-personalization-field') : null;
  }

  function pieceHead(text) {
    var el = document.createElement('div');
    el.className = 'pl-piece-head';
    el.textContent = text;
    return el;
  }

  var pieceState = null;
  function setupPieces() {
    var root = document.querySelector('product-property');
    if (!root) return false;
    var img1 = fieldOf(root, 'input[type="file"][id$="-1"]');
    var img2 = fieldOf(root, 'input[type="file"][id$="-2"]');
    var txt1 = fieldOf(root, 'input[type="text"][id$="-1"]');
    var txt2 = fieldOf(root, 'input[type="text"][id$="-2"]');
    if (!img2 && !txt2) return false; /* segundo conjunto não está ligado no template */
    /* agrupa por peça: foto 1, frase 1, foto 2, frase 2 */
    if (img1 && txt1) img1.after(txt1);
    if (img2 && txt2) img2.after(txt2);
    var label = cfg.label || 'Colar';
    var head1 = pieceHead(label + ' 1');
    var head2 = pieceHead(label + ' 2');
    head2.classList.add('pl-piece-head--sep');
    var first1 = img1 || txt1;
    var first2 = img2 || txt2;
    if (first1) first1.before(head1);
    if (first2) first2.before(head2);
    var note = document.createElement('p');
    note.className = 'pl-piece-note';
    note.hidden = true;
    note.textContent = cfg.note || '';
    (txt2 || img2).after(note);
    pieceState = { second: [head2, img2, txt2].filter(Boolean), note: note };
    return true;
  }

  function updatePieces() {
    if (!pieceState) return;
    var pieces = selectedPieces();
    pieceState.second.forEach(function (field) {
      var show = pieces >= 2;
      field.hidden = !show;
      field.querySelectorAll('input').forEach(function (input) {
        if (input.dataset.plRequired === undefined) input.dataset.plRequired = input.required ? '1' : '0';
        input.disabled = !show; /* campo oculto não é enviado nem exigido */
        input.required = show && input.dataset.plRequired === '1';
      });
    });
    pieceState.note.hidden = !(pieces > 2 && cfg.note);
  }

  /* modo "campos únicos": não separa por peça; só avisa quando o kit tem mais de 1 peça */
  var singleNote = null;
  function setupSingle() {
    var root = document.querySelector('product-property');
    if (!root || !cfg.note) return false;
    var fields = root.querySelectorAll('.custom-personalization-field');
    var last = fields[fields.length - 1];
    if (!last) return false;
    singleNote = document.createElement('p');
    singleNote.className = 'pl-piece-note';
    singleNote.hidden = true;
    singleNote.textContent = cfg.note;
    last.after(singleNote);
    return true;
  }
  function updateSingle() {
    if (singleNote) singleNote.hidden = selectedPieces() <= 1;
  }

  /* ===== modo "clone": repete o grupo inteiro de campos para cada peça ===== */
  var MAX_PIECES = 3;
  var cloneState = null;

  function propName(input) {
    var m = /^properties\[(.*)\]$/.exec(input.getAttribute('name') || '');
    return m ? m[1] : null;
  }

  function setupClone() {
    var root = document.querySelector('product-property');
    if (!root) return false;
    var fields = Array.prototype.slice.call(root.querySelectorAll('.custom-personalization-field'));
    if (!fields.length) return false;
    var label = cfg.label || 'Peça';
    var last = fields[fields.length - 1];
    var groups = [{ head: null, fields: fields }];

    /* título do grupo 1 (só aparece com 2 ou mais peças) */
    var head1 = pieceHead(label + ' 1');
    head1.hidden = true;
    fields[0].before(head1);
    groups[0].head = head1;

    var anchor = last;
    for (var n = 2; n <= MAX_PIECES; n++) {
      var head = pieceHead(label + ' ' + n);
      head.classList.add('pl-piece-head--sep');
      var copies = fields.map(function (f, idx) {
        var c = f.cloneNode(true);
        /* gerador de frases do tema aponta para o campo original: não duplicar */
        c.querySelectorAll('ai-phrase-generator, .ai-phrase-generator, .ai-phrase-generator__editor-notice').forEach(function (e) { e.remove(); });
        var step = c.querySelector('.custom-personalization-field__step');
        if (step) step.textContent = String(fields.length * (n - 1) + idx + 1);
        c.querySelectorAll('[id]').forEach(function (e) { e.id = e.id + '-p' + n; });
        c.querySelectorAll('label[for]').forEach(function (e) { e.setAttribute('for', e.getAttribute('for') + '-p' + n); });
        c.querySelectorAll('input, textarea').forEach(function (inp) {
          var base = propName(inp);
          if (base) inp.setAttribute('name', 'properties[' + label + ' ' + n + ' - ' + base + ']');
          if (inp.type !== 'file') inp.value = '';
          inp.dataset.plOrigRequired = inp.required ? '1' : '0';
        });
        c.querySelectorAll('.custom-personalization-upload__preview').forEach(function (e) { e.hidden = true; });
        c.querySelectorAll('.custom-personalization-upload__empty').forEach(function (e) { e.hidden = false; });
        c.querySelectorAll('.custom-personalization-upload').forEach(function (e) { e.classList.remove('has-file'); });
        return c;
      });
      anchor.after(head);
      var prev = head;
      copies.forEach(function (c) { prev.after(c); prev = c; });
      anchor = prev;
      groups.push({ head: head, fields: copies });
    }

    /* guarda os nomes originais do grupo 1, para renomear quando houver mais de 1 peça */
    fields.forEach(function (f) {
      f.querySelectorAll('input, textarea').forEach(function (inp) {
        var base = propName(inp);
        if (base) inp.dataset.plOrigName = base;
        inp.dataset.plOrigRequired = inp.required ? '1' : '0';
      });
    });

    var note = document.createElement('p');
    note.className = 'pl-piece-note';
    note.hidden = true;
    note.textContent = cfg.note || '';
    anchor.after(note);
    cloneState = { groups: groups, label: label, note: note };
    return true;
  }

  function updateClone() {
    if (!cloneState) return;
    var pieces = selectedPieces();
    cloneState.groups.forEach(function (g, i) {
      var show = i === 0 || i < pieces;
      if (g.head) g.head.hidden = i === 0 ? pieces < 2 : !show;
      g.fields.forEach(function (f) {
        f.hidden = !show;
        f.querySelectorAll('input, textarea').forEach(function (inp) {
          inp.disabled = !show; /* campo oculto não é enviado nem exigido */
          inp.required = show && inp.dataset.plOrigRequired === '1';
          if (i === 0 && inp.dataset.plOrigName) {
            /* com 2+ peças, o pedido identifica de qual peça é cada campo */
            var nm = pieces > 1 ? cloneState.label + ' 1 - ' + inp.dataset.plOrigName : inp.dataset.plOrigName;
            inp.setAttribute('name', 'properties[' + nm + ']');
          }
        });
      });
    });
    cloneState.note.hidden = !(pieces > MAX_PIECES && cfg.note);
  }

  function initCompare(root) {
    root.querySelectorAll('.pl-tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        root.querySelectorAll('.pl-tab').forEach(function (t) { t.classList.toggle('on', t === tab); });
        root.querySelectorAll('.pl-cmp').forEach(function (c) { c.classList.toggle('on', c.dataset.i === tab.dataset.i); });
      });
    });
    root.querySelectorAll('.pl-cmp input').forEach(function (range) {
      range.addEventListener('input', function () {
        range.closest('.pl-cmp').style.setProperty('--pos', range.value + '%');
      });
    });
  }

  function init() {
    decorateKits();
    if (cfg.mode === 'clone') {
      if (setupClone()) {
        updateClone();
        document.addEventListener('change', function (e) {
          if (e.target && e.target.type === 'radio') setTimeout(updateClone, 0);
        });
      }
    } else if (cfg.mode === 'single') {
      if (setupSingle()) {
        updateSingle();
        document.addEventListener('change', function (e) {
          if (e.target && e.target.type === 'radio') setTimeout(updateSingle, 0);
        });
      }
    } else if (setupPieces()) {
      updatePieces();
      document.addEventListener('change', function (e) {
        if (e.target && e.target.type === 'radio') setTimeout(updatePieces, 0);
      });
    }
    document.querySelectorAll('[data-pl-compare]').forEach(initCompare);
    var picker = document.querySelector('.product-detail__variant-picker');
    if (picker && 'MutationObserver' in window) {
      new MutationObserver(decorateKits).observe(picker, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
